import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "list-reports-page",
  class: "page list-reports-page"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_flex, { "align-self-center": "" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("h2", { class: "section-title" }, [
                  _createElementVNode("span", null, "ALL REPORTS")
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_layout, {
              "align-end": "",
              "justify-end": ""
            }, {
              default: _withCtx(() => [
                true
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "filter-btn elevation-6",
                      ripple: false,
                      "data-testid": "FilterBtn",
                      text: "",
                      to: "/reports/generate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { small: "" }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("fas fa-plus", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.fetchingReports || _ctx.reports)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AppTable, {
                  "data-testid": "ReportTable",
                  "table-data": _ctx.tableData,
                  loading: _ctx.fetchingReports,
                  striped: true
                }, null, 8, ["table-data", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.fetchingReports && !_ctx.reports)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}